var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('app-table',{attrs:{"id":"activity-table","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }